const emailValidation = email => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export default emailValidation
